import {
  initialProfileState,
  IProfileState,
} from '@myStore/profile/profile.state';
import {
  EProfileActions,
  ProfileActions,
} from '@myStore/profile/profile.actions';

export const profileReducers = (
  state = initialProfileState,
  action: ProfileActions
): IProfileState => {
  switch (action.type) {
    case EProfileActions.ClearSuccessState: {
      return {
        ...state,
        success: false,
        errors: {},
      };
    }
    case EProfileActions.EditSelfProfile: {
      return {
        ...state,
        loading: { ...state.loading, editProfile: true },
      };
    }
    case EProfileActions.EditSelfProfileFailure: {
      return {
        ...state,
        loading: { ...state.loading, editProfile: false },
        errors: { ...state.errors, editProfile: action.errors },
      };
    }
    case EProfileActions.EditSelfProfileSuccess: {
      return {
        ...state,
        errors: {},
        loading: { ...state.loading, editProfile: false },
      };
    }

    case EProfileActions.ChangePassword: {
      return {
        ...state,
        loading: { ...state.loading, changePassword: true },
        success: false,
      };
    }
    case EProfileActions.ChangePasswordSuccess: {
      return {
        ...state,
        loading: { ...state.loading, changePassword: false },
        errors: { ...state.errors, changePassword: {} },
        success: true,
      };
    }
    case EProfileActions.ChangePasswordFailure: {
      return {
        ...state,
        loading: { ...state.loading, changePassword: false },
        errors: { ...state.errors, changePassword: action.errors },
        success: false,
      };
    }

    case EProfileActions.VerifyEmailFetch: {
      return {
        ...state,
        loading: { ...state.loading, verifyEmail: true },
      };
    }
    case EProfileActions.VerifyEmailFetchFailure: {
      return {
        ...state,
        loading: { ...state.loading, verifyEmail: false },
        errors: { ...state.errors, verifyEmail: action.errors },
      };
    }
    case EProfileActions.VerifyEmailRequestSuccess: {
      return {
        ...state,
        messages: { verifyEmail: action.message },
        errors: {},
        loading: { ...state.loading, verifyEmail: false },
      };
    }

    case EProfileActions.VerifyPhoneRequestSuccess: {
      return {
        ...state,
        messages: { verifyPhone: action.message },
        errors: {},
        loading: { ...state.loading, verifyPhone: false },
      };
    }
    case EProfileActions.VerifyPhoneSuccess: {
      return {
        ...state,
        errors: {},
        user: { ...state.user, is_phone_confirmed: true },
        loading: { ...state.loading, verifyPhone: false },
      };
    }
    case EProfileActions.VerifyPhoneRequestFailure: {
      return {
        ...state,
        errors: { ...state.errors, verifyPhone: action.errors },
        loading: { ...state.loading, verifyPhone: false },
      };
    }

    case EProfileActions.VerifyEmailSuccess: {
      return {
        ...state,
        errors: {},
        user: { ...state.user, is_email_confirmed: true },
      };
    }

    default:
      return state;
  }
};
